import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver, Input } from '@angular/core';
import { modals } from '../../singletons/modals';

@Component({
  selector: 'app-modals',
  template: `
  <router-outlet name="modal"></router-outlet>
  <template #modalcontainer></template>
  `
})
export class ModalsComponent implements OnInit {

  componentRef: any;
  @ViewChild('modalcontainer', { static: true, read: ViewContainerRef }) modal !: ViewContainerRef;

  constructor(
    private resolver: ComponentFactoryResolver
  ) { }

  private createComponent({ component, data }: any) {
    this.modal.clear();
    const factory = this.resolver.resolveComponentFactory(component);
    this.componentRef = this.modal.createComponent(factory);
    /** Set instance properties on the modal */
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        this.componentRef.instance[key] = data[key];
      }
    }
  }

  private destroyComponent() {
    if (this.componentRef) { // necessary if modal was opened in { outlet: modal }
      this.componentRef.destroy();
    }
  }

  ngOnInit() {
    modals.events.subscribe(
      ({ event, data }) => {
        if (event === 'show modal') {
          this.createComponent(data);
        } else if (event === 'hidden modal') {
          this.destroyComponent();
        } else {
          // console.log(event, data);
        }
      }
    );
  }

}
